import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {CommonModule, DatePipe, NgOptimizedImage} from '@angular/common';
import {OdooService} from '@services/odoo.service';
import {ApiService} from '@services/api.service';
import {HttpClientModule} from '@angular/common/http';

@Component({
  selector: 'app-procedure',
  imports: [
    DatePipe, CommonModule, HttpClientModule, NgOptimizedImage
  ],
  templateUrl: './procedure.component.html',
  styleUrl: './procedure.component.css'
})
export class ProcedureComponent implements OnInit {

  @Input() item: any;
  @Output() goBackToProcedures = new EventEmitter<void>();

  @ViewChild('iframe') private iframeElement! : ElementRef<HTMLIFrameElement>;

  @HostListener('document:keyup.escape', ['$event'])
  handleEscapeKey() {
    this.closePreview();
  }

  constructor(
    private odooService: OdooService,
    private apiService: ApiService,
  ) {
  }

  goBack() {
    this.goBackToProcedures.emit()
  }

  ngOnInit(): void {
  }

  fetchProcedure() {
    this.apiService.getProcedure(this.item.id).subscribe(
      (item: any) => {
        this.item = item.data;
      });
  }

  downloadDocument(id: number, type: string) {
    this.apiService.getDocument(id).subscribe((response: any) => {
      const fileBase64 = response.content;
      const fileName = response.fileName;
      const mimeType = type.toLowerCase() || "application/octet-stream";

      const byteCharacters = atob(fileBase64);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: mimeType });

      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(link.href);

    });
  }

  previewDocument(id: number, type: string) {
    this.apiService.getDocument(id).subscribe((response: any) => {
      this.iframeElement.nativeElement.setAttribute('src',`data:${type};base64,${response.content}`);
    });
  }

  closePreview() {
    this.iframeElement.nativeElement.removeAttribute('src');
  }
}
